'use strict'
var pages = angular.module('pagesModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap',
	'ui.tinymce'	
]);
require('./allpages/js/directive/allpagesDirective.js')(pages);
require('./allpages/js/allpagesController.js')(pages);
require('./edit-newpage/js/directive/pageDirective.js')(pages);
require('./edit-newpage/js/pageController.js')(pages);
// require('./edit-newpage/js/directive/tinymceDirective.js')(pages);
// require('./editTemplateDirective.js')(pages);
// require('./quickEditDirective.js')(pages);



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/pagesModule/pagesModule.js
// module id = 539
// module chunks = 0